import React, { useEffect, useState } from "react";

import { getSupaClient } from "../../lib/supabase";

/**
 * Loads the survey and formats its questions
 * @param {*} currentTrigger - the current trigger to edit
 * @returns
 *  loading: wethr the hook is still loading
    savedSurveyList: a list of saved surveys for the current team
    setSavedSurveyList: callback to update the survey list
    selectedSavedSurveyId: the id of the current survey
    setSelectedSavedSurveyId: callback to update the current survey id
    surveyName: the current survey name
    setSurveyName: callback to update the current survey name
    welcomeMessage: the current welcome message in the survey
    setWelcomeMessage: callback to update the current welcome message
    questionsData: the questions data for the current survey
    setQuestionsData: calback to update the current questions data
    teamTags: the team tags
    setTeamTags: callback to update the team tags 
 */
function useSavedSurveys(currentTrigger) {
  const teamId = localStorage.getItem("team-id");
  const supabase = getSupaClient();

  const [loading, setLoading] = useState(false);
  const [savedSurveyList, setSavedSurveyList] = useState([]);
  const [selectedSavedSurveyId, setSelectedSavedSurveyId] = useState(null);
  const [surveyName, setSurveyName] = useState("");
  const [welcomeMessage, setWelcomeMessage] = useState({});
  const [teamTags, setTeamTags] = useState([]);
  const [questionsData, setQuestionsData] = useState([
    {
      question_type: "one",
      questionValue: "",
      question_id: 1,
      options: [
        { text: "", id: 1, tags: [], memberTags: [], memberTagsId: [] },
        { text: "", id: 2, tags: [], memberTags: [], memberTagsId: [] },
      ],
    },
  ]);

  /**
   * Load the current team's tags
   */
  const loadTeamTags = async () => {
    const { data, error } = await supabase
      .from("tags")
      .select("id, name, color")
      .eq("team", teamId);
    if (data) {
      setTeamTags(data);
    }
    if (error) {
      console.log("Error", error);
    }
  };

  /**
   * Load Saved Survey from saved_surveys
   */
  const loadSavedSurvey = async () => {
    const { data, error } = await supabase
      .from("saved_surveys")
      .select("id, name, survey_content, is_template")
      .filter("team", "eq", teamId);

    if (error) {
      console.log("Error loading saved survey", error);
      window.analytics.track("Saved Survey load error");
    }
    if (data && data[0]) {
      setSavedSurveyList(data);
    }
    if (selectedSavedSurveyId || currentTrigger) {
      // Format questions
      let selectedSaveSurvey;
      if (selectedSavedSurveyId) {
        selectedSaveSurvey = data.filter(
          (item) => item.id === selectedSavedSurveyId
        );
      } else {
        selectedSaveSurvey = data.filter(
          (item) => item.id === currentTrigger.config[0].survey_id
        );
      }
      setSurveyName(selectedSaveSurvey[0].name);
      const savedWelcomeMessage =
        selectedSaveSurvey[0].survey_content.onboarding_questions[0];
      let onboardingQuestions;
      if (savedWelcomeMessage.question_type === "message") {
        setWelcomeMessage({
          text: savedWelcomeMessage.message,
        });
        onboardingQuestions =
          selectedSaveSurvey[0].survey_content.onboarding_questions.splice(1);
      } else {
        setWelcomeMessage({
          text: "",
        });
        onboardingQuestions =
          selectedSaveSurvey[0].survey_content.onboarding_questions;
      }
      const formatedQuestions = onboardingQuestions.map((item, count) => {
        return {
          questionValue: item.question,
          question_id: count + 1,
          question_type: item.question_type,
          options: item.answers.map((answer, answerCount) => {
            return {
              id: answerCount + 1,
              text: answer.display,
              memberTags: answer.maps_to_tags.map(
                (tagId) => teamTags.filter((teamTag) => teamTag.id === tagId)[0]
              ),
              tags: answer.maps_to_tags.map(
                (tagId) => teamTags.filter((teamTag) => teamTag.id === tagId)[0]
              ),
              memberTagsId: answer.maps_to_tags,
            };
          }),
        };
      });
      setQuestionsData(formatedQuestions);
    }
  };

  const readySurvey = async () => {
    setLoading(true);
    await loadTeamTags();
    await loadSavedSurvey();
    setLoading(false);
  };

  useEffect(() => {
    readySurvey();
  }, [selectedSavedSurveyId, currentTrigger]);

  return {
    loading,
    savedSurveyList,
    setSavedSurveyList,
    selectedSavedSurveyId,
    setSelectedSavedSurveyId,
    surveyName,
    setSurveyName,
    welcomeMessage,
    setWelcomeMessage,
    questionsData,
    setQuestionsData,
    teamTags,
    setTeamTags,
  };
}

export default useSavedSurveys;
